export class CredentialApplicationStatusesReportModel {
  renewalApplicationStatuses: string[];
  reinstateApplicationStatuses: string[];
  constructor(data?: CredentialApplicationStatusesReportModel) {
    if (!data) return;
    this.reinstateApplicationStatuses = data.reinstateApplicationStatuses;
    this.renewalApplicationStatuses = data.renewalApplicationStatuses;
  }
}
